import * as React from 'react';

/** Seuil unique du produit : en dessous de 768 px on est en mise en page mobile. */
export const MOBILE_BREAKPOINT = 768;

const MEDIA_QUERY = `(max-width: ${String(MOBILE_BREAKPOINT - 1)}px)`;

function subscribe(onStoreChange: () => void): () => void {
  const query = window.matchMedia(MEDIA_QUERY);
  query.addEventListener('change', onStoreChange);
  return () => {
    query.removeEventListener('change', onStoreChange);
  };
}

function getSnapshot(): boolean {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useIsMobile(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
